const config = JSON.parse(import.meta.env.VITE_FIREBASE_CONFIG);

export const firebaseConfig = config!;
